var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-switch__wrapper"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',{staticClass:"v-switch",class:_vm.classes,attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }